export const GRAPHQL_ENDPOINT_HEADER = 'X-Graphql-Endpoint';
export const ACCEPT_HEADER = 'Accept';
export const CONTENT_TYPE_HEADER = 'Content-Type';
export const AUTHORIZATION = 'Authorization';

